(function () {
  const syncActiveAltGroup = (wrapper, slide) => {
    if (!wrapper) return;
    if (!slide || slide.hidden) {
      wrapper.removeAttribute("data-active-alt-group");
      return;
    }
    const group = slide.getAttribute("data-alt-group");
    if (group) {
      wrapper.setAttribute("data-active-alt-group", group);
    } else {
      wrapper.removeAttribute("data-active-alt-group");
    }
  };

  const resolveSelectedSlide = (carousel) =>
    carousel.selectedSlide ||
    carousel.querySelector(".product-gallery__media.is-selected:not([hidden])") ||
    carousel.querySelector(".product-gallery__media:not([hidden])");

  const bindGallery = (gallery) => {
    if (gallery.dataset.mediaGroupIconBound === "true") return;

    const wrapper = gallery.querySelector(".product-gallery__media-list-wrapper");
    const carousel = gallery.querySelector("media-carousel");
    if (!wrapper || !carousel || !wrapper.querySelector(".product-gallery__media-group-icon")) return;

    gallery.dataset.mediaGroupIconBound = "true";

    carousel.addEventListener("carousel:change", (event) => {
      syncActiveAltGroup(wrapper, event.detail?.slide);
    });

    carousel.addEventListener("carousel:settle", () => {
      syncActiveAltGroup(wrapper, resolveSelectedSlide(carousel));
    });

    gallery.addEventListener("control:filter", () => {
      syncActiveAltGroup(wrapper, resolveSelectedSlide(carousel));
    });

    syncActiveAltGroup(wrapper, resolveSelectedSlide(carousel));
  };

  const init = (root = document) => {
    root.querySelectorAll(".product-gallery-2603").forEach(bindGallery);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
